import React, { useEffect, useState } from "react";
import { FiTrash2, FiSettings, FiPlus } from "react-icons/fi";
import { BASE_URL } from "../../../utils/constant";
import { csrftoken } from "../../../utils/DjangoCSRFToken";
import ProjectAccess from "./ProjectAccess";
import AddProjectform from "./AddProjectform";
import { MdOutlinePersonOutline } from "react-icons/md";
import { Clock } from "lucide-react";
import { useAlert } from "components/UI_components/Alert";
export default function AddedProjectsTab({
  userId,
  selectedMember,
  currentMember,
}) {
  // console.log("AddedProjectsTab rendered");
  const { addAlert } = useAlert();
  const [selectedProject, setSelectedProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      const accessToken = localStorage.getItem("access");
      const organization_id = JSON.parse(
        localStorage.getItem("organization")
      )?.id;
      const userData = JSON.parse(localStorage.getItem("user"));

      if (!accessToken || !organization_id) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${BASE_URL}/sites/organizations/${organization_id}/sites/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": csrftoken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const sitesData = await response.json();

        const sitesWithMembers = await Promise.all(
          sitesData.map(async (site) => {
            try {
              const membersRes = await fetch(
                `${BASE_URL}/team/list-site-members/${site.id}/`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrftoken,
                    Authorization: `Bearer ${accessToken}`,
                  },
                }
              );
              const membersData = await membersRes.json();
              const members = membersData.status ? membersData.data : [];
              // Compare as strings for type safety
              const isUserMember = members.some(
                (m) => String(m.user_id) === String(userId)
              );

              // if (isUserMember) {
              //   // console.log("User is a member of site:", site.site_name);
              // } else {
              //   // console.log("User is NOT a member of site:", site.site_name);
              // }

              return isUserMember
                ? { ...site, name: site.site_name, users: members }
                : null;
            } catch {
              return null;
            }
          })
        );

        const filtered = sitesWithMembers.filter(Boolean);
        // console.log("Filtered projects:", filtered);
        setProjects(filtered);
      } catch (error) {
        console.error("Error fetching projects", error);
        setProjects([]);
      }

      setLoading(false);
    };

    fetchProjects();
  }, [refetch]);

  const deleteMemberFromProject = async (memberId, projectId) => {
    const accessToken = localStorage.getItem("access");
    const organization_id = JSON.parse(
      localStorage.getItem("organization")
    )?.id;
    if (!accessToken || !organization_id) {
      console.error("Access token or organization ID is missing");
      return;
    }
    try {
      const response = await fetch(
        `${BASE_URL}/team/delete-member/${memberId}/`,
        {
          method: "DELETE",
          headers: {
            "X-CSRFToken": csrftoken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const data = await response.json();
      if (data.status) {
        addAlert("Member removed successfully from the site", "success");
        // Update state locally to immediately remove the project without refetching
        setProjects((prevProjects) => prevProjects.filter((p) => p.id !== projectId));
      } else {
        console.error("Failed to remove member:", data.message);
        addAlert(`Failed to remove member: ${data.message}`, "error");
      }
    } catch (error) {
      console.error("Error removing member:", error);
    }
  };

  const handleRemoveMemberFromProject = async (project) => {
    const member = project.users.find(
      (user) => String(user.user_id) === String(userId)
    );
    // console.log("Member to remove:", member);
    if (!member) {
      console.error("Member not found in project:", project);
      addAlert("Member not found in project", "error");
      return;
    }
    try {
      await deleteMemberFromProject(member.member_id, project.id);
    } catch (error) {
      console.error("Error removing member from project:", error);
      addAlert("Failed to remove member from project", "error");
    }
  };

  if (selectedProject) {
    return (
      <ProjectAccess
        project={selectedProject}
        onBack={() => {
          setSelectedProject(null);
          setRefetch((prev) => !prev);
        }}
        member={
          selectedProject.users &&
          selectedProject.users.find(
            (user) => user.user_id === selectedMember.user.id
          )
        }
        currentMember={currentMember}
      />
    );
  }

  return (
    <div className="bg-white rounded-xl p-3 px-1 space-y-6">
      <div className="flex items-center justify-between border-b-[1.6px] border-sm-border mb-2 pb-3 pl-3 pr-2 w-full">
        {/* Project count on the left */}
        <span className="text-[#737373] text-sm font-medium">
          {projects.length} added project{projects.length !== 1 ? "s" : ""}
        </span>
        {/* Buttons on the right */}
        <div className="flex items-center gap-3">
          {/* <button
            className="border border-purple-600 text-purple-600 bg-white px-5 py-2 rounded-full font-medium text-sm hover:bg-purple-50 transition"
            type="button"
          >
            MAE-Project
          </button> */}
          <button
            className="bg-btn-bg text-sm hover:bg-purple-900 text-white px-3 py-2 rounded-lg font-medium justify-between flex flex-row items-center"
            onClick={() => setShowAddProjectModal(true)}
            style={{
              rowGap: "12px",
              display: currentMember?.joined_as === "owner" ? "flex" : "none",
            }}
          >
            <div className="bg-[#58267F] rounded-full p-1 mr-2">
              <FiPlus className="" />
            </div>
            Add Project
          </button>
        </div>
      </div>
      {showAddProjectModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ background: "rgba(0,0,0,0.4)" }}
        >
          <div className="bg-white rounded-xl shadow-lg p-6 relative min-w-[350px] max-w-full">
            <AddProjectform
              onClose={() => {
                setShowAddProjectModal(false);
                setRefetch((prev) => !prev); // Trigger refetch after adding a project
              }}
              userId={userId}
              selectedMember={selectedMember}
            />
          </div>
        </div>
      )}
      {loading ? (
        <p className="text-gray-400 italic">Loading projects...</p>
      ) : projects.length === 0 ? (
        <p className="text-gray-400 italic">No projects found.</p>
      ) : (
        <ul className="divide-y">
          {projects.map((project) => {
            // console.log("Rendering project in list:", project);
            return (
              <li
                key={project.id}
                className="py-3 flex justify-between items-center"
              >
                <div>
                  <p className="font-semibold text-lg text-[#1B2559]">
                    {project.name}
                  </p>
                  <p className="text-xs text-[#A3AED0]">
                    {project.address ||
                      project.site_address ||
                      project.location ||
                      "No address"}
                  </p>
                </div>
                <div
                  className="flex gap-4"
                  style={{
                    display:
                      currentMember?.joined_as === "owner" ? "flex" : "none",
                  }}
                >
                  <button
                    onClick={() => handleRemoveMemberFromProject(project)}
                    className="border-[1px] border-red-500 text-red-600 px-4 py-1.5 rounded-full hover:bg-red-50 font-semibold text-sm flex items-center gap-1"
                  >
                    <FiTrash2 /> Remove
                  </button>

                  {/* Coming Soon Manage Button */}
                  <div className="relative">
                    <button
                      className="border-[1px] border-gray-600 text-black px-4 py-1.5 rounded-full font-semibold text-sm flex items-center gap-1 cursor-pointer"
                      // disabled
                      onClick={() => {
                        setSelectedProject(project);
                      }}
                    >
                      <MdOutlinePersonOutline /> Manage
                    </button>

                    {/* Coming Soon Badge */}
                    {/* <div className="absolute -top-2 -right-2 bg-gradient-to-r from-orange-400 to-pink-500 text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1 shadow-sm animate-pulse">
                      <Clock className="w-3 h-3" />
                      <span className="font-medium">Soon</span>
                    </div> */}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
